function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import deepmerge from 'deepmerge';
import { produce, setAutoFreeze } from 'immer';
import { escapeRegExp, isArray, isEmpty, isEqual, isNil, isObject, omit } from 'lodash-es';
export function produceWithoutFreeze(state, cb) {
    setAutoFreeze(false);
    const nextState = produce(state, cb);
    setAutoFreeze(true);
    return nextState;
}
export function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
export function encodeParams(params) {
    const encodedParams = {};
    Object.keys(params).forEach((key)=>{
        // decode uri component and then encoding make sure its not double encoded
        encodedParams[key] = encodeURIComponent(decodeURIComponent(params[key]));
    });
    return encodedParams;
}
export const removeEmptyParams = (obj, { recursive, removeEmptyStrings } = {})=>{
    const newObj = _object_spread({}, obj);
    Object.keys(newObj).forEach((k)=>{
        const key = k;
        const value = newObj[key];
        if (removeEmptyStrings && value === '' || isNil(value)) {
            delete newObj[key];
        } else if (typeof value === 'object' && !isArray(value) && recursive) {
            const updatedValue = removeEmptyParams(value, {
                recursive,
                removeEmptyStrings
            });
            if (isEmpty(updatedValue)) delete newObj[key];
        }
    });
    return newObj;
};
export const removeEmptyParamsAndStrings = (obj, recursive)=>{
    return removeEmptyParams(obj, {
        recursive,
        removeEmptyStrings: true
    });
};
export function isObjectLiteral(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
export function matchesPropertyPath(propertyPath, pathToMatch) {
    const pathToMatchRegex = new RegExp(`${escapeRegExp(pathToMatch)}${pathToMatch.endsWith('.') ? '' : '($|\\.|\\[)'}`);
    return Boolean(propertyPath.match(pathToMatchRegex));
}
export function getParentPath(path, pathDelimeter = '.') {
    const parentPathParts = path.split(pathDelimeter);
    parentPathParts.pop();
    return parentPathParts.join(pathDelimeter);
}
export function isObjectEqual(obj1, obj2, pathsToIgnore = []) {
    pathsToIgnore.forEach((path)=>{
        if (isObject(obj1)) obj1 = omit(obj1, path);
        if (isObject(obj2)) obj2 = omit(obj2, path);
    });
    return isEqual(obj1, obj2);
}
export function downloadTextAsFile(filename, text) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
export function blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (typeof reader.result === 'string') {
                resolve(reader.result.split(',')[1]);
            } else {
                reject(new Error('Failed to convert blob to base64'));
            }
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}
export function base64ToAudioUrl(base64, format) {
    return `data:audio/${format};base64,${base64}`;
}
export const mergeObjects = (A, B)=>{
    if (!B) return A;
    return deepmerge(A, B, {
        arrayMerge: (_A, _B)=>_B
    });
};
export const deepFreeze = (obj)=>{
    if (Object.isFrozen(obj)) return obj;
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    const typedObj = obj;
    Object.keys(typedObj).forEach((key)=>{
        if (typeof typedObj[key] === 'object' && typedObj[key] !== null) {
            deepFreeze(typedObj[key]);
        }
    });
    return Object.freeze(typedObj);
};
export const firstOfSet = (set)=>{
    return set.values().next().value;
};
export const isStringifiedEqual = (a, b)=>{
    return JSON.stringify(a) === JSON.stringify(b);
};
